import React, { Component } from 'react';

import styles from './_styles/LoadingIcon.module.scss';

export default class LoadingIcon extends Component {

	render() {
		return <div className={styles.LoadingIcon}></div>;
	}
}